import React from 'react'
import { Link } from 'react-router-dom'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI.js'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI.js'
import ClientDataNavUI from '../../../components/superUser/clientData/ClientDataNavUI.js'
import SelectUI from '../../../widgets/input/SelectUI.js'
import CardUI from '../../../widgets/layout/CardUI.js'
import './CreditReportPage.css'
import LinkWithSpinnerUI from '../../../widgets/action/LinkWithSpinnerUI.js'

const CreditReportPageUI = ({ context, account, onRefreshClick,
  userId, userList, onUserChange, CCRResponse, onCreditReportDownloadClick, downloadMode,
  onCommercialCreditReportDownloadClick, download2Mode
}) =>
  <SuperUserAccountPageUI context={context} className='pg_su_acc_cr' backLink='/su/accounts'
    headerText={`${account ? account.accountName : ''}`} centered={!account} dimension='w1000'
    account={account} page='clientData'
  >
    {
      (!account) &&
      <SpinnerComponentUI />
    }
    {
      account &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <div className='g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <span className='g_m_left_100 g_large'><b>Credit report</b></span>
            </div>
          }
          right={<span />}
        />
        <ClientDataNavUI account={account} page='creditReport' />

      </div>
    }
    <div className='g_flex_h g_flex_right'>
      <LinkWithSpinnerUI className='g_m_right_50' label='Download commercial credit report'
        onClick={onCommercialCreditReportDownloadClick}
        busy={download2Mode} />
      {
        userId &&
        <LinkWithSpinnerUI className='g_m_right_50' label='Download credit report'
          onClick={onCreditReportDownloadClick} rowId={userId}
          busy={downloadMode} />
      }
      <SelectUI selectedKey={userId} optionList={userList} onChange={onUserChange} placeholder='User' />
    </div>
    {
      CCRResponse &&
      <CCRResponseUI CCRResponse={CCRResponse} />
    }
  </SuperUserAccountPageUI>

const CCRResponseUI = ({ CCRResponse }) => (
  <div>
    {/* <InquiryResponseHeaderUI header={CCRResponse.CIRReportDataLst[0].InquiryResponseHeader} /> */}
    <CardUI className='g_m_bottom_100'>
      <InquiryRequestInfoUI info={CCRResponse.CIRReportDataLst[0].InquiryRequestInfo} />
    </CardUI>
    {
      CCRResponse.CIRReportDataLst[0].CIRReportData &&
      <div>
        <CardUI className='g_m_bottom_100'>
          <ScoreUI score={CCRResponse.CIRReportDataLst[0].CIRReportData.ScoreDetails[0]} />
        </CardUI>
        <CardUI className='g_m_bottom_100'>
          <PersonalInfo personalInfo={CCRResponse.CIRReportDataLst[0].CIRReportData.IDAndContactInfo.PersonalInfo} />
          <IdentityInfo identityInfo={CCRResponse.CIRReportDataLst[0].CIRReportData.IDAndContactInfo.IdentityInfo} />
          <AddressInfo addressInfo={CCRResponse.CIRReportDataLst[0].CIRReportData.IDAndContactInfo.AddressInfo} />
        </CardUI>
        <CardUI>
          {/* <EnquiriesUI enquiryList={CCRResponse.CIRReportDataLst[0].CIRReportData.Enquiries} /> */}
          <EnquirySummaryUI enquirySummary={CCRResponse.CIRReportDataLst[0].CIRReportData.EnquirySummary} />
        </CardUI>
      </div>
    }
  </div>
);

const InquiryRequestInfoUI = ({ info }) => (
  <div>
    <h2>Inquiry Request Info</h2>
    <p>Inquiry Purpose: {info.InquiryPurpose}</p>
    <p>First Name: {info.FirstName}</p>
    <h3>Inquiry Addresses</h3>
    {info.InquiryAddresses.map((address, index) => (
      <Address key={index} address={address} />
    ))}
    <h3>Inquiry Phones</h3>
    {info.InquiryPhones.map((phone, index) => (
      <Phone key={index} phone={phone} />
    ))}
    <h3>ID Details</h3>
    {info.IDDetails.map((idDetail, index) => (
      <IDDetail key={index} idDetail={idDetail} />
    ))}
    <p>Date of Birth: {info.DOB}</p>
    <h3>MFI Details</h3>
    {info.MFIDetails.FamilyDetails.map((familyDetail, index) => (
      <FamilyDetail key={index} familyDetail={familyDetail} />
    ))}
  </div>
);

const Address = ({ address }) => (
  <div>
    <p>Address Line 1: {address.AddressLine1}</p>
    <p>State: {address.State}</p>
    <p>Postal: {address.Postal}</p>
  </div>
);

const Phone = ({ phone }) => (
  <div>
    <p>Phone Type: {phone.PhoneType}</p>
    <p>Number: {phone.Number}</p>
  </div>
);

const IDDetail = ({ idDetail }) => (
  <div>
    <p>ID Type: {idDetail.IDType}</p>
    <p>ID Value: {idDetail.IDValue}</p>
    <p>Source: {idDetail.Source}</p>
  </div>
);

const FamilyDetail = ({ familyDetail }) => (
  <div>
    <p>Additional Name Type: {familyDetail.AdditionalNameType}</p>
    <p>Additional Name: {familyDetail.AdditionalName}</p>
  </div>
);

const ScoreUI = ({ score }) => (
  <div>
    <h2>Score</h2>
    <p>Name: {score.Name}</p>
    <p>Type: {score.Type}</p>
    <p>Value: {score.Value}</p>
    <p>Version: {score.Version}</p>
    <div>
      <table>
        <tbody>
          <tr>
            <td><h2>Code</h2></td>
            <td className='g_p_left_100'><h2>Type</h2></td>
            <td className='g_p_left_100'><h2>Description</h2></td>
          </tr>
          {
            score.ScoringElements && score.ScoringElements.map((scores, i) =>
              <tr key={i}>
                <td>{scores.code}</td>
                <td className='g_p_left_100'>{scores.type}</td>
                <td className='g_p_left_100'>{scores.Description}</td>
              </tr>
            )
          }
        </tbody>
      </table>
    </div>
  </div>
);

const PersonalInfo = ({ personalInfo }) => {
  return (
    <div>
      <h2>Personal Information</h2>
      <p>Full Name: {personalInfo.Name.FullName}</p>
      <p>Date of Birth: {personalInfo.DateOfBirth}</p>
      <p>Gender: {personalInfo.Gender}</p>
      <p>Occupation: {personalInfo.Occupation}</p>
      <p>Marital Status: {personalInfo.MaritalStatus}</p>
    </div>
  );
};

const IdentityInfo = ({ identityInfo }) => {
  return (
    <div>
      <h2>Identity Information</h2>
      <div className='g_flex_h g_flex_left'>
        {
          identityInfo.PANId &&
          <div>
            <h3>PAN</h3>
            {
              identityInfo.PANId.map((id, index) => (
                <div key={index}>
                  <p>Seq: {id.seq}</p>
                  <p>Reported Date: {id.ReportedDate}</p>
                  <p>ID Number: {id.IdNumber}</p>
                </div>
              ))}
          </div>
        }
        {
          identityInfo.PassportID &&
          <div className='g_m_left_100'>
            <h3>Passport Id</h3>
            {
              identityInfo.PassportID.map((id, index) => (
                <div key={index}>
                  <p>Seq: {id.seq}</p>
                  <p>Reported Date: {id.ReportedDate}</p>
                  <p>ID Number: {id.IdNumber}</p>
                </div>
              ))}
          </div>
        }
        {
          identityInfo.DriverLicence &&
          <div className='g_m_left_100'>
            <h3>Driver Licence</h3>
            {
              identityInfo.DriverLicence.map((id, index) => (
                <div key={index}>
                  <p>Seq: {id.seq}</p>
                  <p>Reported Date: {id.ReportedDate}</p>
                  <p>ID Number: {id.IdNumber}</p>
                </div>
              ))}
          </div>
        }
        {
          identityInfo.VoterID &&
          <div className='g_m_left_100'>
            <h3>Voter Id</h3>
            {
              identityInfo.VoterID.map((id, index) => (
                <div key={index}>
                  <p>Seq: {id.seq}</p>
                  <p>Reported Date: {id.ReportedDate}</p>
                  <p>ID Number: {id.IdNumber}</p>
                </div>
              ))}
          </div>
        }
        {
          identityInfo.NationalIDCard &&
          <div className='g_m_left_100'>
            <h3>National Id Card</h3>
            {
              identityInfo.NationalIDCard.map((id, index) => (
                <div key={index}>
                  <p>Seq: {id.seq}</p>
                  <p>Reported Date: {id.ReportedDate}</p>
                  <p>ID Number: {id.IdNumber}</p>
                </div>
              ))}
          </div>
        }
        {
          identityInfo.RationCard &&
          <div className='g_m_left_100'>
            <h3>Ration Card</h3>
            {
              identityInfo.RationCard.map((id, index) => (
                <div key={index}>
                  <p>Seq: {id.seq}</p>
                  <p>Reported Date: {id.ReportedDate}</p>
                  <p>ID Number: {id.IdNumber}</p>
                </div>
              ))}
          </div>
        }
        {
          identityInfo.OtherId &&
          <div className='g_m_left_100'>
            <h3>Other Id</h3>
            {
              identityInfo.OtherId.map((id, index) => (
                <div key={index}>
                  <p>Seq: {id.seq}</p>
                  <p>Reported Date: {id.ReportedDate}</p>
                  <p>ID Number: {id.IdNumber}</p>
                </div>
              ))}
          </div>
        }
      </div>
    </div>
  );
};

const AddressInfo = ({ addressInfo }) => {
  return (
    <div>
      <h2>Address Information</h2>
      {addressInfo.map((address, index) => (
        <div key={index}>
          <p>Seq: {address.Seq}</p>
          <p>Reported Date: {address.ReportedDate}</p>
          <p>Address: {address.Address}</p>
          <p>State: {address.State}</p>
          <p>Postal: {address.Postal}</p>
        </div>
      ))}
    </div>
  );
};

const EnquiriesUI = ({ enquiryList }) =>
  <div>
    <h2>Enquiries</h2>
    <table>
      <thead>
        <tr>
          <th>Institution</th>
          <th className='g_p_left_100'>Date</th>
          <th className='g_p_left_100'>Time</th>
        </tr>
      </thead>
      <tbody>
        {
          enquiryList.map((enquiries, i) =>
            <tr key={i}>
              <td>{enquiries.Institution}</td>
              <td className='g_p_left_100'>{enquiries.Date}</td>
              <td className='g_p_left_100'>{enquiries.Time}</td>
            </tr>
          )
        }
      </tbody>
    </table>
  </div>

const EnquirySummaryUI = ({ enquirySummary }) =>
  <div>
    <h2>Enquiry Summary</h2>
    <p>Purpose: {enquirySummary.Purpose}</p>
    <p>Total: {enquirySummary.Total}</p>
    <p>Past 30 Days: {enquirySummary.Past30Days}</p>
    <p>Past 12 Months: {enquirySummary.Past12Months}</p>
    <p>Past 24 Months: {enquirySummary.Past24Months}</p>
    <p>Recent: {enquirySummary.Recent}</p>
  </div>

export default CreditReportPageUI
